import { gallery } from "../utils";
const GalleryComp = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-4">
          {gallery.map((service, index) => {
            return (
              <div
                key={index}
                className="col-md-4 col-lg-4 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="col-lg-12 col-md-12 portfolio-item first">
                  <div className="portfolio-img rounded overflow-hidden">
                    <img
                      className="img-fluid"
                      /* src="img/img-600x400-6.jpg" */
                      src={`img/gallery/g${index + 1}.jpg`}
                      alt={service.name}
                    />
                    <div className="portfolio-btn">
                      <a
                        className="btn btn-lg-square btn-outline-light rounded-circle mx-1"
                        href={`img/gallery/g${index + 1}.jpg`}
                        data-lightbox="portfolio"
                      >
                        <i className="fa fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default GalleryComp;
